export default "__VITE_ASSET__BrbkggVT__"